import { render } from "./PopoverWithLimits.vue?vue&type=template&id=08f89b31&scoped=true"
import script from "./PopoverWithLimits.vue?vue&type=script&lang=js"
export * from "./PopoverWithLimits.vue?vue&type=script&lang=js"

import "./PopoverWithLimits.vue?vue&type=style&index=0&id=08f89b31&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08f89b31"]])

export default __exports__